import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';

interface RoleRow {
  key: string;
  name: string | null;
}

// Devolve as keys dos papéis do utilizador autenticado.
export function useRoles() {
  const [roles, setRoles] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    (async () => {
      const { data, error } = await supabase
        .from('user_roles')
        .select('role:role_id(key, name)');
      if (!error && active) {
        const rows = data as unknown as { role: RoleRow }[] | null;
        setRoles(rows?.map((r) => r.role?.key).filter(Boolean) ?? []);
      }
      if (active) setLoading(false);
    })();
    return () => {
      active = false;
    };
  }, []);

  return { roles, loading };
}

export function hasRole(roles: string[], key: string) {
  return roles.includes(key);
}